const roles: any = {
  SUPER_ADMIN: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: true,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: false,
    APPLICATION_MANAGEMENT: false,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
  DOM_ADMIN: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: true,
    ORGANIZATION_MANAGEMENT: true,
    PERMISSION_MANAGEMENT: true,
    ADVANCED_API_MANAGEMENT: true,
    APPLICATION_MANAGEMENT: true,
    ROLE_MANAGEMENT: true,
    USERS_AND_GROUP_MANAGEMENT: true,
    AUTHENTICATION_SETTINGS: true,
  },
  ORG_ADMIN: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: true,
    PERMISSION_MANAGEMENT: true,
    ADVANCED_API_MANAGEMENT: true,
    APPLICATION_MANAGEMENT: true,
    ROLE_MANAGEMENT: true,
    USERS_AND_GROUP_MANAGEMENT: true,
    AUTHENTICATION_SETTING: false,
  },
  API_PUBLISHER: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: true,
    APPLICATION_MANAGEMENT: true,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
  API_DEVELOPER: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: true,
    APPLICATION_MANAGEMENT: true,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
  EXECUTIVE_ROLE: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: false,
    APPLICATION_MANAGEMENT: false,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
  WEBAPP_ROLE: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: false,
    APPLICATION_MANAGEMENT: true,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
  SYSTEM_ROLE: {
    DASHBOARD: true,
    DOMAIN_MANAGEMENT: false,
    ORGANIZATION_MANAGEMENT: false,
    PERMISSION_MANAGEMENT: false,
    ADVANCED_API_MANAGEMENT: false,
    APPLICATION_MANAGEMENT: false,
    ROLE_MANAGEMENT: false,
    USERS_AND_GROUP_MANAGEMENT: false,
    AUTHENTICATION_SETTING: false,
  },
};

const MANAGE_OPERATIONS = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ORGANIZATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  PERMISSION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  USER_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  GROUP_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: true,
    mapping: true,
    export: true,
  },
};

const SUPER_ADMIN_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const MANAGE_DOMAIN_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: true,
    delete: false,
    mapping: true,
    export: true,
  },
  ORGANIZATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  PERMISSION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  USER_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  GROUP_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: true,
    create: true,
    export: true,
    delete: true,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: true,
    mapping: true,
    export: true,
  },
};

const MANAGE_ORG_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  PERMISSION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: true,
    create: true,
    export: true,
    delete: true,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: true,
    mapping: true,
    export: true,
  },
};

const WEBAPP_USER_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const API_PUBLISHER_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: true,
    create: true,
    export: true,
    delete: true,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const API_DEVELOPER_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: true,
    edit: true,
    delete: true,
    mapping: true,
    export: true,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: true,
    mapping: true,
    export: true,
  },
};

const EXECUTIVE_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const SYSTEM_ORG_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const DOM_ADMIN_OPERATIONS: any = {
  DOMAIN_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ORGANIZATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PERMISSION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  USER_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  APPLICATION_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  ROLES_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  GROUP_MANAGEMENT: {
    create: false,
    edit: false,
    delete: false,
    mapping: false,
    export: false,
  },
  PUBLISHERPORTAL_MANAGEMENT: {
    edit: false,
    create: false,
    export: false,
    delete: false,
  },
  DEVPORTAL_MANAGEMENT: {
    edit: false,
    mapping: false,
    export: false,
  },
};

const MAPPING = {
  SYSTEM_ROLE: 'MANAGE_OPERATIONS',
  DOM_ADMIN: 'MANAGE_DOMAIN_OPERATIONS',
  ORG_ADMIN: 'MANAGE_ORG_OPERATIONS',
  USER_ROLE: 'MANAGE_USER_OPERATIONS',
};

const DOMAIN_MANAGEMENT = {
  createDomain: true,
  editDomain: true,
  deleteDomain: true,
  activeDomain: true,
  addMappingDomain: true,
  deleteMappingDomain: true,
  exportDomain: true,
};

const ORGANIZATION_MANAGEMENT = {
  createOrganization: true,
  editOrganization: true,
  deleteOrganization: true,
  activeOrganization: true,
  addMappingOrganization: true,
  deleteMappingOrganization: true,
  exportOrganization: true,
};

const GROUP_MANAGEMENT = {
  createGroup: true,
  editGroup: true,
  deleteGroup: true,
  activeGroup: true,
  addMappingGroup: true,
  deleteMappingGroup: true,
  exportGroup: true,
};

const ROLES_MANAGEMENT = {
  createRoles: true,
  editRoles: true,
  deleteRoles: true,
  activeRoles: true,
  addMappingRoles: true,
  deleteMappingRoles: true,
  exportRoles: true,
};

const USER_MANAGEMENT = {
  create: true,
  edit: true,
  delete: true,
  mapping: true,
  export: true,
};

export {
  roles,
  DOMAIN_MANAGEMENT,
  ORGANIZATION_MANAGEMENT,
  MANAGE_OPERATIONS,
  USER_MANAGEMENT,
  GROUP_MANAGEMENT,
  ROLES_MANAGEMENT,
  MAPPING,
  MANAGE_DOMAIN_OPERATIONS,
  MANAGE_ORG_OPERATIONS,
  SUPER_ADMIN_OPERATIONS,
  WEBAPP_USER_OPERATIONS,
  API_DEVELOPER_OPERATIONS,
  API_PUBLISHER_OPERATIONS,
  EXECUTIVE_OPERATIONS,
  SYSTEM_ORG_OPERATIONS,
};
/**
Create new domain
edit domain
delete particular domain
active / inactive domain
domain mapping - add / delete
export
*/
